import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { GridDataResult, SortSettings } from "@progress/kendo-angular-grid";
import {
  CompositeFilterDescriptor,
  process,
  SortDescriptor
} from "@progress/kendo-data-query";
import { BehaviorSubject } from "rxjs";
import { IMyTask } from "src/app/interfaces";
import { isNullOrWhiteSpace } from "src/app/interfaces/string";
import { LogClass, Logger, LogMethod } from "src/app/logger";

@LogClass({ source: "My-Task-Grid" })
@Component({
    selector: "circ-my-tasks-grid",
    templateUrl: "./my-tasks-grid.component.html",
    styleUrls: ["./my-tasks-grid.component.scss"],
    standalone: false
})
export class MyTasksGridComponent implements OnInit, OnChanges {
  @Input() gridData: IMyTask[] = [];
  @Input() initialSort: SortDescriptor[];
  @Output() cellClick = new EventEmitter<IMyTask>();
  @Output() sortChange = new EventEmitter<SortDescriptor[]>();

  public gridView$ = new BehaviorSubject<GridDataResult>(null);
  public sortSettings: SortSettings = {
    allowUnsort: true,
    mode: "single"
  };
  public sort: SortDescriptor[] = [
    {
      field: "dueDate",
      dir: "desc"
    }
  ];

  private filterValue: string = null;
  private logger: Logger;

  ngOnInit(): void {
    this.onSortChange(this.initialSort);
  }

  @LogMethod()
  public onSortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.sortChange.emit(sort);
    this.loadGridView();
  }

  @LogMethod()
  ngOnChanges(changes: SimpleChanges): void {
    if (typeof changes["gridData"] === "undefined") {
      return;
    }

    this.loadGridView();
  }

  @LogMethod()
  private loadGridView() {
    if (!this.gridData) {
      this.logger.info("Data is null");
      this.gridView$.next(null);
      return;
    }

    this.gridView$.next(
      process(this.gridData, {
        sort: this.sort,
        filter: this.getFilter(this.filterValue)
      })
    );
  }

  @LogMethod()
  public onFilter(input: string): void {
    this.filterValue = input;
    this.loadGridView();
  }

  @LogMethod()
  public onCellClick({ dataItem }: { dataItem: IMyTask }): void {
    this.cellClick.emit(dataItem);
  }

  @LogMethod()
  private getFilter(value: string): CompositeFilterDescriptor {
    if (isNullOrWhiteSpace(value)) {
      return null;
    }

    return {
      logic: "or",
      filters: [
        {
          field: "stepTitle",
          operator: "contains",
          value: value
        },
        {
          field: "circulationTitle",
          operator: "contains",
          value: value
        }
      ]
    };
  }
}
